/* eslint-disable import/no-anonymous-default-export */
export default {
  GENERATE_OTP: () => "/driver/auth/generateLoginOtp",
  LOGIN_WITH_OTP: () => "/driver/auth/loginWithMobileOtp",
};
